import { TaskStatus, type TaskStatus as TaskStatusValue } from '../../domain/routine/enums';
import { useTranslation } from '../design-system/data/translations';

const LABEL_KEYS: Record<TaskStatusValue, string> = {
  [TaskStatus.pending]: 'status.pending',
  [TaskStatus.inProgress]: 'status.in_progress',
  [TaskStatus.completed]: 'status.completed',
  [TaskStatus.skipped]: 'status.skipped',
  [TaskStatus.postponed]: 'status.postponed',
};

export function StatusBadge({ status }: { readonly status: TaskStatusValue }) {
  const { t } = useTranslation();
  return <span className={`status-badge status-badge--${status}`}>{t(LABEL_KEYS[status])}</span>;
}
